import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useContext, useMemo } from 'react';
import { getEnterpriseRoute } from 'utils';

export default function useUserEnterpriseRoute() {
  const { isRWCMember, isOfficeManager, isRegularEnterpriseMember, enterprise } =
    useContext(CurrentUserContext);

  return useMemo(() => {
    if (!enterprise) return '';

    const { _id, isDemo } = enterprise;

    // RWC ignores the subroute and lands on the RWC area, except for plain
    // members, whose only page is suggested actions.
    if (isRWCMember) {
      const rwcRoute = getEnterpriseRoute(true, isDemo, _id);

      return isRegularEnterpriseMember
        ? `${rwcRoute}/suggested-actions`
        : rwcRoute;
    }

    // Outside RWC every enterprise user (heads, office managers and plain
    // members) lands on their enterprise overview.
    return getEnterpriseRoute(
      false,
      isDemo,
      _id,
      isOfficeManager ? 'team' : 'analytics',
    );
  }, [enterprise, isOfficeManager, isRegularEnterpriseMember, isRWCMember]);
}
